<!--
  @project E-School Web
  @author Vothana CHY
  @date 2026-07-28
-->

<script lang="ts" setup>
import { useI18n } from '#imports';

const { t } = useI18n();
</script>

<template>
  <div
    class="flex min-h-[30vh] flex-col items-center justify-center rounded-3xl border border-gray-100 bg-white p-8 text-center shadow-xs"
  >
    <Icon name="lucide:folder-search" class="mb-3 h-12 w-12 text-slate-300" />
    <h3 class="text-base font-bold text-gray-900">
      {{ t('courses.noCoursesFound') }}
    </h3>
    <p class="mt-1 text-xs text-slate-500">
      {{ t('courses.noCoursesFoundDesc') }}
    </p>
  </div>
</template>
